import { useLocation } from 'react-router-dom'
// import giginoPaneVino from '../Resources/giginoPaneVino.png'
const pathMap = [
  { path: '/login', label: 'Login' }
]

export const usePageTitle = () => {
  useLocation()
  if (window.location.pathname === '/') return 'Home'

  const matchTitle = ({ path, include }) => include ? window.location.pathname.includes(path) : path === window.location.pathname

  return pathMap.find(matchTitle)?.label || 'Home'
}

export const useMenuItems = ({ role }) => ([
  { label: 'Home', icon: 'fa-duotone fa-house-blank', path: '/environments/list' },
  { label: 'Test', icon: 'fa-duotone fa-flask', path: '/test' },
  { label: 'Logout', icon: 'fa-duotone fa-power-off', path: 'logout' }
])
